import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

import {MAIN_APP} from '../MidiPlay.jsx';

import UtilIcon from '../util/UtilIcon.jsx';
import UtilDropdown from '../util/UtilDropdown.jsx';
import Colors from '../resource/ResourceColors.jsx';

const IconSelectWrapper = styled.div`
    float: left;
    display: inline-block;
`;

const IconHolder = styled.div`
    float: left;
    height: 100%;
    cursor: pointer;
    vertical-align: top;
    margin-top: -0.35rem;
    margin-left: 1rem;
    margin-right: 0.1rem;
    font-size: 2rem;
    filter: ${Colors.medium_shadow(25)};    
`;

const CaretHolder = styled.div`
    float: left;
    height: 100%;
    width: 0.5rem;
    cursor: pointer;
    margin-top: 0.5rem;
    filter: ${Colors.medium_shadow(60)};  
`;

export class InterfaceIconDropdown extends Component {

    static propTypes = {
        icon_name: PropTypes.string.isRequired,
        icon_size: PropTypes.string.isRequired,
        icon_color: PropTypes.string.isRequired,
        icon_bgcolor: PropTypes.string,
        icon_style: PropTypes.object,
        dropdown_options: PropTypes.array.isRequired,
        dropdown_handler: PropTypes.func,
        tooltip: PropTypes.string.isRequired
    }

    state = {
        caret_hover: false,
        target_ref: null,
    };

    componentDidMount() {
        this.setState({target_ref: React.createRef()});
    }

    mouse_over_icon(e) {
        if (MAIN_APP.state.dropdown) {
            const dropdown = MAIN_APP.state.dropdown;
            if (dropdown.name !== this.props.icon_name) {
                this.caret_dropdown(e)
            }
        }
        this.setState({caret_hover: true});
    }

    mouse_out_icon(e) {
        this.setState({caret_hover: false});
    }

    caret_dropdown(e) {
        const target = this.state.target_ref.current;
        if (target) {
            e.preventDefault();
            const bounds = target.getBoundingClientRect();
            const location = {x: bounds.left, y: bounds.bottom};
            const dropdown = <UtilDropdown
                location={location}
                items={this.props.dropdown_options}
                listener={(item) => this.props.dropdown_handler(item)}>
            </UtilDropdown>;
            MAIN_APP.setState({dropdown: dropdown});
        }
    }

    render() {
        const icon = this.props.icon_bgcolor ?
            <UtilIcon
                hover
                icon={this.props.icon_name}
                color={this.props.icon_color}
                bgColor={this.props.icon_bgcolor}
                absSize={this.props.icon_size}
                style={this.props.icon_style}/> :
            <UtilIcon
                hover solid
                icon={this.props.icon_name}
                color={this.props.icon_color}
                absSize={this.props.icon_size}
                style={this.props.icon_style}/>

        const caret_style = {display: this.state.caret_hover ? 'block' : 'none'}
        return <IconSelectWrapper
            onMouseOut={(e) => this.mouse_out_icon(e)}
            onMouseOver={(e) => this.mouse_over_icon(e)}>
            <IconHolder
                ref={this.state.target_ref}
                title={this.props.tooltip}
                onClick={(e) => this.props.dropdown_options[0].handler}>
                {icon}
            </IconHolder>
            <CaretHolder
                onClick={(e) => this.caret_dropdown(e)}>
                <UtilIcon
                    solid
                    icon="caret-down"
                    absSize='1rem'
                    color={Colors.primary(90)}
                    style={caret_style}/>
            </CaretHolder>
        </IconSelectWrapper>
    }
}

export default InterfaceIconDropdown;